import { Component, ViewEncapsulation, OnInit } from '@angular/core';

import { MergeUniquePipe } from '@app/pipes';

import { CatalogueService } from '@app/services/catalogue';
import { DialogService } from '@app/services/dialog';
import { NavigationService } from '@app/services/navigation';

@Component({
    selector: 'page-accessories',
    templateUrl: './accessories.page.html',
    styleUrls: ['./accessories.page.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AccessoriesPage implements OnInit {
    public loaded: boolean = false;

    public tags: string[] = ['diy kitchens - website', 'accessories section'];
    public categories = [];
    public items: any;

    private mergeUnique = new MergeUniquePipe();

    constructor(
        private catalogueService: CatalogueService,
        private dialogService: DialogService,
        private navigationService: NavigationService
    ) {
        this.navigationService.setNavigation({
            title: 'Accessories',
            metaTags: [
                { name: 'no-meta', content: 'no metadata' },
                { name: 'description', content: 'See our range of Accessories - You can put your personal stamp on the kitchen and really make it your own with hand-picked touches of individuality.'},
            ],
            routeHistory: [{ title: 'Accessories', route: '/accessories' }]
        });
    }

    ngOnInit() {
        this.catalogueService.getAccessories()
            .then((accessories: any) => {
                if (accessories) {
                    let categories = this.mergeUnique.transform(accessories.map(product => product.cat));

                    this.categories = categories.map(category => {
                        this.items = accessories.filter(product => product.cat === category && product.price > 0);
                        let itemCount = this.items.length;

                        return {
                            name: category,
                            route: category.toLowerCase().replace(/ /g, '-'),
                            tag: category.toLowerCase().replace(/ /g, ' '),
                            itemCount: itemCount,
                            countName: 'products'
                        };
                    });
                    this.loaded = true;
                }
            })
            .catch((error) => this.dialogService.error(this.constructor.name, error));
    }
}
